import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.find";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.replace";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/work/admin/sdk_manage_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _toConsumableArray from "D:/work/admin/sdk_manage_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/sdk_manage_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import Vue from 'vue';
import VueRouter from 'vue-router';
import layoutHeaderAside from '@/layout/header-aside'; // 进度条

import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import store from '@/store/index';
import util from '@/libs/util.js'; // 路由数据

import routes from './routes'; // fix vue-router NavigationDuplicated

var VueRouterPush = VueRouter.prototype.push;

VueRouter.prototype.push = function push(location) {
  return VueRouterPush.call(this, location).catch(function (err) {
    return err;
  });
};

var VueRouterReplace = VueRouter.prototype.replace;

VueRouter.prototype.replace = function replace(location) {
  return VueRouterReplace.call(this, location).catch(function (err) {
    return err;
  });
}; // 固定菜单与路由


import { menuAside, menuHeader } from '@/menu';
import { frameInRoutes } from '@/router/routes';

var _import = require('@/libs/util.import.' + process.env.NODE_ENV);

Vue.use(VueRouter); // 导出路由 在 main.js 里使用

var router = new VueRouter({
  routes: routes
});

var fetchPermissionInfo = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var InceptionRouter, formatRoutes, RouterList, accessMenus, isDevelop, targetTitle, indexRoute, openedList, processMenuTitle, allMenuAside, allMenuHeader;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            InceptionRouter = function InceptionRouter(list) {
              list.map(function (i, index) {
                i.children.map(function (k) {
                  i.children = [].concat(_toConsumableArray(i.children), _toConsumableArray(k.children));
                  k.children = [];
                });
              });
            }; // (resolve) => require([`@/views${route.path}`], resolve)


            formatRoutes = function formatRoutes(routes) {
              routes.forEach(function (route) {
                route.component = route.path == "" ? layoutHeaderAside : _import(route.path.slice(1));

                if (route.children.length) {
                  formatRoutes(route.children);
                }
              });
            };

            _context.next = 4;
            return store.dispatch('d2admin/db/get', {
              dbName: 'sys',
              path: 'menu.accessMenus',
              defaultValue: [],
              user: true
            }, {
              root: true
            });

          case 4:
            RouterList = _context.sent;
            _context.next = 7;
            return store.dispatch('d2admin/permission/generateAccessMenus', RouterList);

          case 7:
            accessMenus = _context.sent;
            InceptionRouter(RouterList);
            formatRoutes(RouterList); // let allMenuAside = [...menuAside, ...accessMenus]
            // let allMenuHeader = [...menuHeader, ...accessMenus]
            //动态添加路由

            router.addRoutes(RouterList); // 处理路由 得到每一级的路由设置

            store.commit('d2admin/page/init', [].concat(_toConsumableArray(frameInRoutes), _toConsumableArray(RouterList))); //如果是研发，将首页修改为产品

            isDevelop = store.state.d2admin.user.info.is_develop == 1;
            targetTitle = isDevelop ? '产品' : '首页'; // 1. 修改静态注册的 frameInRoutes 中 index 的 meta.title

            indexRoute = frameInRoutes[0] && frameInRoutes[0].children ? frameInRoutes[0].children.find(function (r) {
              return r.name === 'index';
            }) : null;

            if (indexRoute && indexRoute.meta) {
              indexRoute.meta.title = targetTitle;
            } // 2. 修改持久化存储（DB）里的 page.opened 缓存，防止 DB 里的旧数据覆盖了新标题


            _context.next = 18;
            return store.dispatch('d2admin/db/get', {
              dbName: 'sys',
              path: 'page.opened',
              defaultValue: [],
              user: true
            }, {
              root: true
            });

          case 18:
            openedList = _context.sent;

            if (!(openedList && openedList.length)) {
              _context.next = 23;
              break;
            }

            openedList = openedList.map(function (item) {
              if (item.name === 'index' || item.fullPath === '/index') {
                item.meta = item.meta || {};
                item.meta.title = targetTitle;
              }

              return item;
            });
            _context.next = 23;
            return store.dispatch('d2admin/db/set', {
              dbName: 'sys',
              path: 'page.opened',
              value: openedList,
              user: true
            }, {
              root: true
            });

          case 23:
            // 2. 动态替换菜单中的 "首页" 文本
            processMenuTitle = function processMenuTitle(menuList) {
              return menuList.map(function (item) {
                var newItem = _objectSpread({}, item);

                if (newItem.path === '/index' || newItem.name === 'index') {
                  newItem.title = targetTitle; // 动态替换为 "产品" 或 "首页"
                }

                if (newItem.children && newItem.children.length) {
                  newItem.children = processMenuTitle(newItem.children);
                }

                return newItem;
              });
            };

            allMenuAside = processMenuTitle([].concat(_toConsumableArray(menuAside), _toConsumableArray(accessMenus)));
            allMenuHeader = processMenuTitle([].concat(_toConsumableArray(menuHeader), _toConsumableArray(accessMenus))); // 设置顶栏菜单

            store.commit('d2admin/menu/headerSet', allMenuHeader); // 设置侧边栏菜单

            store.commit('d2admin/menu/asideSet', allMenuAside); // 初始化菜单搜索功能

            store.commit('d2admin/search/init', allMenuHeader); // 加载上次退出时的多页列表

            store.dispatch('d2admin/page/openedLoad');
            _context.next = 32;
            return Promise.resolve();

          case 32:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchPermissionInfo() {
    return _ref.apply(this, arguments);
  };
}(); //免校验token白名单


var whiteList = ['/login'];
/**
 * 路由拦截
 * 权限验证
 */

router.beforeEach( /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(to, from, next) {
    var token, state;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            // 进度条
            NProgress.start(); // 关闭搜索面板

            store.commit('d2admin/search/set', false);
            token = util.cookies.get('token');

            if (!(whiteList.indexOf(to.path) === -1)) {
              _context2.next = 20;
              break;
            }

            if (!(token && token !== 'undefined')) {
              _context2.next = 16;
              break;
            }

            //拉取权限信息
            state = store.state.d2admin.permission.isFetchPermissionInfo;

            if (state) {
              _context2.next = 13;
              break;
            }

            _context2.next = 9;
            return fetchPermissionInfo();

          case 9:
            store.commit('d2admin/permission/setFet', true);
            next(to.path, true);
            _context2.next = 14;
            break;

          case 13:
            next();

          case 14:
            _context2.next = 18;
            break;

          case 16:
            // 将当前预计打开的页面完整地址临时存储 登录后继续跳转
            // 这个 cookie(redirect) 会在登录后自动删除
            util.cookies.set('redirect', to.fullPath); // 没有登录的时候跳转到登录界面

            next({
              name: 'login'
            });

          case 18:
            _context2.next = 21;
            break;

          case 20:
            if (to.name === 'login') {
              // 如果已经登录，则直接进入系统
              if (token && token !== undefined) {
                next(from.path, true);
                NProgress.done();
              } else {
                next();
              }
            } else {
              next();
            }

          case 21:
            NProgress.done();

          case 22:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function (_x, _x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}());
router.afterEach(function (to) {
  // 进度条
  NProgress.done(); // 需要的信息
  // const app = router.app
  // const { name, params, query } = to
  // 多页控制 打开新的页面

  store.dispatch('d2admin/page/open', to); // 更改标题

  util.title(to.meta.title);
});
export default router;